import React from 'react';
import PropTypes from 'prop-types';

// Components
import SVG from 'components/widgets/icons/svg';
import Tooltip from 'components/widgets/overlays/tooltip';

// Utils
import { getFileOpenUrl } from 'utils/google-drive-utils';


export default function RecordingLink({ item }) {
  return (
    <a href={getFileOpenUrl(item.recording.fileId)} target="_blank">
      <Tooltip title="View recording in Google Drive">
        <SVG src="svg/play.svg" className="play-recording" />
      </Tooltip>
    </a>
  );
}

RecordingLink.propTypes = {
  item: PropTypes.object.isRequired
};



// WEBPACK FOOTER //
// ./app/components/models/triage/recording-link.js